import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from '@/store/store';
import Vuetify from 'vuetify';
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

import '@/components';
import '@/components/answers';
import '@/components/questions';
import '@/components/intros';
import '@/components/officemanagement';
import '@/components/admin';
import '@/components/navigation';
import { SURVEY_MODEL_DATA } from '@/common/surveyData';
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vuetify/dist/vuetify.min.css';
import TextareaAutosize from 'vue-textarea-autosize';
import VueScrollactive from 'vue-scrollactive';
import ConstPlugin from '@/plugins/ConstPlugin.js'

// import { questionBase } from '@/components/questions/QuestionBase';

Vue.config.productionTip = false;

// Vue.mixin(questionBase);
Vue.use(Vuetify);
Vue.use(BootstrapVue);
Vue.use(TextareaAutosize);
Vue.use(VueScrollactive);
Vue.use(ConstPlugin);
Vue.use(Chartkick.use(Chart));

SURVEY_MODEL_DATA.surveyStore = store;

new Vue({
	icons: {
		iconfont: 'mdi' // default - only for display purposes
	},
	router,
	store,
	vuetify: new Vuetify(),
	render: h => h(App)
}).$mount('#app');
